import axios from 'axios';
import { getAuthToken } from './auth';

export const ADMIN_AUTH_FAILURE_EVENT = 'samsar-admin:auth-failure';

export const adminApi = axios.create({
  baseURL: process.env.REACT_APP_PROCESSOR_API,
});

adminApi.interceptors.request.use((config) => {
  const authToken = getAuthToken();
  if (authToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  return config;
});

adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || '';
    if ((status === 401 || status === 403) && requestUrl.includes('/admin')) {
      window.dispatchEvent(new Event(ADMIN_AUTH_FAILURE_EVENT));
    }
    return Promise.reject(error);
  }
);
